import * as React from "react"

import { cn } from "@/lib/utils"

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          // The 3px focus glow is a `ring`, not a `shadow`: chromeless embeds
          // (chat composer, canvas editors, inline renames) suppress it with
          // `focus-visible:ring-0`, and tailwind-merge can only strip a
          // conflicting utility from the same group + variant. A
          // `focus-visible:shadow-*` glow survives a base `shadow-none`.
          "border-input placeholder:text-muted-foreground focus-visible:border-primary focus-visible:ring-primary/15 flex min-h-[60px] w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-sm transition-[box-shadow,border-color] duration-200 ease-out focus-visible:ring-3 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
